export const sendToHubspot = (route: string) => {
  if (typeof window === 'undefined') return
  const hubspotWindow = window as any
  hubspotWindow._hsq = hubspotWindow._hsq || []
  const _hsq = hubspotWindow._hsq
  _hsq.push(['setPath', route])
  _hsq.push(['trackPageView'])
}
